import { memo } from 'react';

import HelpIconSVG from '@/assets/help-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IHelpIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={HelpIconSVG} {...props} />;

export const HelpIcon = memo(IHelpIcon) as typeof IHelpIcon;
